import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEAL_EXPLORER_FILTERS_KEY } from '../constants';
import { DealExplorerFilterState } from '../pages/DealExplorer/types';

interface IState {
	data: DealExplorerFilterState;
	guestSearchId: string | null;
	guestSearchUserId?: number | null;
	guestSearchFilters?: DealExplorerFilterState | null;
}

interface IActions {
	persistFiltersState: (updates: Partial<DealExplorerFilterState>) => void;
	resetFiltersState: VoidFunction;
	setInitialState: (
		useGuestDealSearch: boolean,
		userId: number | null,
	) => void;
	setGuestSearchId: (searchId: string | null, userId: number | null) => void;
}

export const initialGuestDealExplorerFiltersState: DealExplorerFilterState = {
	state: null,
	county: null,
	city: null,
	zipCode: null,
	propertyStatus: 1,
	minPrice: '90000',
	maxPrice: '120000',
	minCashFlow: '700',
	sellerFinancingChecked: false,
	showFavourite: false,
	bedrooms: ['-1'],
};

export const initialDealExplorerFilersState: IState = {
	guestSearchId: null,
	guestSearchUserId: null,
	guestSearchFilters: null,
	data: {
		state: null,
		county: null,
		city: null,
		zipCode: null,
		propertyStatus: 1,
		minPrice: '55000',
		maxPrice: '150000',
		minCashFlow: '250',
		sellerFinancingChecked: false,
		showFavourite: false,
		bedrooms: ['-1'],
	},
};

export const usePersistDealExplorerStore = create(
	persist<IState & IActions>(
		(set, get) => ({
			...initialDealExplorerFilersState,
			persistFiltersState: updates =>
				set(state => ({
					...state,
					data: { ...state.data, ...updates },
				})),
			resetFiltersState: () => {
				set(initialDealExplorerFilersState);
			},
			setGuestSearchId: (guestSearchId, userId) =>
				set(state => ({
					guestSearchId,
					guestSearchUserId: guestSearchId ? userId : null,
					guestSearchFilters: guestSearchId
						? { ...state.data }
						: null,
					data: guestSearchId
						? state.data
						: { ...initialGuestDealExplorerFiltersState },
				})),
			setInitialState: (useGuestDealSearch, userId) => {
				const state = get();
				if (!useGuestDealSearch) {
					if (state.guestSearchId && !state.guestSearchFilters) {
						set({ guestSearchFilters: { ...state.data } });
					}
					return;
				}

				if (
					state.guestSearchId &&
					(!state.guestSearchUserId ||
						state.guestSearchUserId === userId)
				) {
					if (state.guestSearchFilters) {
						set({ data: { ...state.guestSearchFilters } });
					} else {
						set({ guestSearchFilters: { ...state.data } });
					}
					return;
				}

				set({
					data: { ...initialGuestDealExplorerFiltersState },
					guestSearchId: null,
					guestSearchUserId: null,
					guestSearchFilters: null,
				});
			},
		}),
		{
			name: DEAL_EXPLORER_FILTERS_KEY,
			version: 1,
		},
	),
);
